var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, validator, TransformValidateDateTime, TransformValidateModel,
//TransformValidateModel,
 } from "@musicaudienceexchange/toccata";
export class Asset extends Model {
}
__decorate([
    validator.IsString()
], Asset.prototype, "path", void 0);
export class Assets extends Model {
}
__decorate([
    TransformValidateModel(Asset)
], Assets.prototype, "image", void 0);
export class Item extends Model {
}
Item.defaults = {
    quantity: 1,
    minAmount: 100,
    processedAt: null,
    closedAt: null,
    canceledAt: null,
};
__decorate([
    validator.IsString()
], Item.prototype, "name", void 0);
__decorate([
    validator.IsString()
], Item.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Assets)
], Item.prototype, "assets", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsOptional()
], Item.prototype, "showBidMinutes", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Item.prototype, "winningNotification", void 0);
__decorate([
    validator.IsNumber()
], Item.prototype, "quantity", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsDivisibleBy(100)
], Item.prototype, "minAmount", void 0);
__decorate([
    TransformValidateDateTime()
], Item.prototype, "startAt", void 0);
__decorate([
    TransformValidateDateTime()
], Item.prototype, "endAt", void 0);
__decorate([
    TransformValidateDateTime()
], Item.prototype, "createdAt", void 0);
__decorate([
    TransformValidateDateTime()
], Item.prototype, "updatedAt", void 0);
__decorate([
    TransformValidateDateTime(),
    validator.ValidateIf((_, v) => v !== null)
], Item.prototype, "closedAt", void 0);
__decorate([
    TransformValidateDateTime(),
    validator.ValidateIf((_, v) => v !== null)
], Item.prototype, "canceledAt", void 0);
__decorate([
    TransformValidateDateTime(),
    validator.ValidateIf((_, v) => v !== null)
], Item.prototype, "processedAt", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsOptional()
], Item.prototype, "winningBids", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsOptional()
], Item.prototype, "order", void 0);
/**
 * /setlive_events/{eventId}/auction_bid/{bidId}
 */
export class Bid extends Model {
}
Bid.defaults = {
    sendAlerts: false,
};
__decorate([
    validator.IsString()
], Bid.prototype, "itemId", void 0);
__decorate([
    validator.Min(100),
    validator.IsNumber(),
    validator.IsDivisibleBy(100)
], Bid.prototype, "amount", void 0);
__decorate([
    validator.IsString()
], Bid.prototype, "uid", void 0);
__decorate([
    validator.IsString()
], Bid.prototype, "paymentMethodId", void 0);
__decorate([
    validator.IsBoolean()
], Bid.prototype, "sendAlerts", void 0);
__decorate([
    validator.IsBoolean()
], Bid.prototype, "alerted", void 0);
__decorate([
    TransformValidateDateTime()
], Bid.prototype, "createdAt", void 0);
__decorate([
    TransformValidateDateTime()
], Bid.prototype, "updatedAt", void 0);
//# sourceMappingURL=auction.js.map